// extracted by mini-css-extract-plugin
module.exports = {"label-radio-align":"LabelRadioAlign_label-radio-align_1WXVp","label":"LabelRadioAlign_label_3yBks"};